//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Decimal",
  props: ["value"],
  data: () => ({
    storedNumber: 0.00,
    comparisonOperator: null,
    comparisonList: [
      //{label: "escolha comparador", value: null},
      { label: "Igual", value: "=" },
      { label: "Diferente", value: "!=" },
      { label: "Menor", value: "<" },
      { label: "Menor ou Igual", value: "<=" },
      { label: "Maior", value: ">" },
      { label: "Maior ou Igual", value: ">=" },
      { label: "Valor Nulo", value: "= null" },
      { label: "Valor não Nulo", value: "!= null" }
    ],
  }),
  mounted: function () {
    if (this.value) {
      this.storedNumber = this.value.value;
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  },
  computed: {
    decimal: {
      get() {
        return this.storedNumber;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          value: value,
          comparisonOperator: this.comparisonOperator.value
        });
        this.storedNumber = value;
      },
    },
    //Disables the value input if no operator is chosen or the null operators are selected
    hasSelectedOperator: {
      get() {
        return this.comparisonOperator == null || this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null"
      }
    }
  },
  methods: {
    updateValues: function () {
      if (this.comparisonOperator.value == "= null" || this.comparisonOperator.value == "!= null") {
        this.$emit("input", {
          ...this.value,
          value: "",
          comparisonOperator: this.comparisonOperator.value
        });
        this.storedNumber = 0.00;
      } else {
        this.$emit("input", {
          ...this.value,
          value: this.storedNumber,
          comparisonOperator: this.comparisonOperator.value
        });
      }
    }
  },
  watch: {
    value: function () {
      if (this.value.value != this.storedNumber) {
        this.storedNumbers = this.value.value;
      }
      this.comparisonOperator = this.comparisonList.find(e => e.value === this.value.comparisonOperator);
    }
  }
};
